export type CalendarDateRange = {
  fromDate: string;
  throughDate: string;
};

const formatCalendarDate = (date: Date, timeZone: string): string => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    calendar: 'gregory',
    numberingSystem: 'latn',
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes): string => parts.find(value => value.type === type)?.value ?? '';
  return `${part('year').padStart(4, '0')}-${part('month')}-${part('day')}`;
};

/** Formats dates in the brokerage IANA zone, falling back to the browser's local IANA zone before list metadata arrives. */
export const getDefaultCustomDateRange = (
  now: Date = new Date(),
  calendarTimeZone?: string | null,
): CalendarDateRange => {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  let throughDate: string;
  try {
    throughDate = formatCalendarDate(now, calendarTimeZone || browserTimeZone);
  } catch {
    throughDate = formatCalendarDate(now, browserTimeZone);
  }
  const from = new Date(`${throughDate}T00:00:00.000Z`);
  from.setUTCDate(from.getUTCDate() - 7);
  return { fromDate: from.toISOString().slice(0, 10), throughDate };
};
